exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table .deActive-row {\r\n    background: rgba(255, 22, 0, 0.15);\n}\n.el-table .success-row {\r\n    background: rgba(17, 249, 0, 0.13);\n}\r\n", ""]);

// exports
